import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { apiClient } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import type { CreateTwitterAdParams, CreateTwitterAdResponse } from './types';

export const createTwitterAd = async (
  body: CreateTwitterAdParams,
): Promise<CreateTwitterAdResponse> => {
  const res = await apiClient.post<CreateTwitterAdResponse>(queryKeys.createAd, body);

  if (isAxiosError(res)) {
    const error = new Error('Axios error');
    error.cause = {
      ...res.response?.data,
      status: res.response?.status,
    };
    return Promise.reject(error);
  }

  return res.data;
};

interface UseCreateTwitterAdOptions {
  config?: MutationConfig<typeof createTwitterAd>;
}

export const useCreateTwitterAd = ({ config }: UseCreateTwitterAdOptions = {}) =>
  useMutation({
    ...config,
    mutationFn: createTwitterAd,
  });
